export default "/images/f3e1e1033955df2a4583c3b927eaf0bb.avif";